<template>
  <modal name="cancel-request-modal" :height="'auto'" :width="'480'" :adaptive="true" :clickToClose="false">
    <div class="flex items-center justify-between p-4 border-b">
      <h4 class="text-base font-semibold">Talep İptal</h4>
      <button @click="$modal.hide('cancel-request-modal')"><i class="fas fa-times"></i></button>
    </div>

    <div v-if="item" class="p-4 space-y-3">
      <div class="bg-yellow-50 border border-yellow-300 rounded p-2 text-xs text-yellow-800">
        <i class="fas fa-exclamation-triangle mr-1"></i>
        <strong>{{ item.vehiclePlate }}</strong> plakalı aracın talebi iptal edilecek. Bu işlem geri alınamaz.
      </div>

      <div>
        <label class="text-xs text-gray-600 mb-1 block">İptal Nedeni</label>
        <textarea v-model="reason" rows="3" class="w-full border border-gray-300 rounded px-2 py-1 text-xs"
          placeholder="İptal nedenini giriniz (örn: Yanlış araç onaylandı)"></textarea>
      </div>

      <div v-if="item.stationName" class="flex items-center text-xs">
        <input id="notifyStation" v-model="notifyStation" type="checkbox" class="mr-2" />
        <label for="notifyStation" class="text-gray-700">
          İstasyona ({{ item.stationName }}) iptal SMS'i gönder
        </label>
      </div>

      <div class="flex space-x-2 pt-2 border-t">
        <button class="flex-1 px-3 py-2 bg-red-600 text-white text-xs rounded" :disabled="saving || !reason" @click="confirm">
          <i class="fas fa-ban mr-1"></i>{{ saving ? 'İşleniyor...' : 'İptal Et' }}
        </button>
        <button class="flex-1 px-3 py-2 bg-gray-400 text-white text-xs rounded" @click="$modal.hide('cancel-request-modal')">Vazgeç</button>
      </div>
    </div>
  </modal>
</template>

<script>
import axios from "axios";
import { fuel } from "@/networking/urlmanager";

export default {
  name: "cancel-request-modal",
  props: { item: { type: Object, default: null } },
  data() {
    return {
      saving: false,
      reason: "",
      notifyStation: true,
    };
  },
  methods: {
    confirm() {
      if (!this.item || !this.reason) return;
      this.saving = true;
      axios.post(fuel.requestCancel, {
        requestId: this.item.id,
        cancelReason: this.reason,
        notifyStation: this.notifyStation,
      }, {
        headers: { Authorization: "Bareer " + this.$store.state.userData.token },
      })
        .then(() => {
          this.$modal.hide("cancel-request-modal");
          this.$emit("cancelled", this.item.id);
          this.$emit("refresh");
          this.swalBox("success", "Talep İptal Edildi", "", false);
        })
        .catch((err) => { this.errorBox(err.response); })
        .finally(() => { this.saving = false; });
    },
  },
  watch: {
    item() { this.reason = ""; this.notifyStation = true; },
  },
};
</script>
